import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import store from '../store';
import {isETicketRoute} from './config';

const ALL_NAMESPACES = ['attendance', 'cluster', 'event', 'global', 'layout', 'login', 'mailing', 'package', 'permission', 'security', 'ticket', 'team', 'newEvent', 'errors', 'publish', 'branding', 'variables', 'realtime', 'promotionMessage', 'cash', 'crowd', 'suspendedConfirmation', 'whatsapp', 'subscriptions', 'timetable', 'eTicket'];
const ETICKET_NAMESPACES = ['eTicket'];

const normalizeI18nLanguage = (input) => {
    const base = String(input ?? '')?.trim()?.split(/[-_]/)[0]?.toLowerCase();
    return base === 'en' ? 'en' : 'he';
};

const detectLanguage = () => {
    let lang = detectUserLanguage();
    lang = normalizeI18nLanguage(lang);
    if(lang === 'he-IL'){
        lang = 'he';
    }
    if(lang === 'en-Us'){
        lang = 'en';
    }
    if(lang === 'en_us'){
        lang = 'en';
    }
    return lang;
};

const detectUserLanguage = () => {
    let state = store.getState();
    if(window.location.search.match(/lang=(.*)&/))
        return window.location.search.match(/lang=(.*)&/)[1];
    if(window.location.search.match(/lang=(.*)/))
        return window.location.search.match(/lang=(.*)/)[1];
    if(state.auth?.isLoggedIn)
        return state.user.lang;
    // if(REACT_APP_ENV !== 'production'){
    //     //for DEVELOPMENT:
    //     return 'en';
    // }
    //for PRODUCTION:
    // Guarded: a malformed stored value (e.g. bare `he` instead of `"he"`) made
    // JSON.parse throw inside the init .then(), silently killing changeLanguage
    // and leaving react-i18next suspended forever (infinite loader on that device).
    try {
        const langloc = JSON.parse(localStorage.getItem('user.langloc'));
        if(langloc)
            return langloc;
    } catch (e) {
        console.error('invalid user.langloc in localStorage, falling back to navigator.language', e);
    }
    return navigator.language;
};

const configI18next = () => {
    const namespaces = isETicketRoute ? ETICKET_NAMESPACES : ALL_NAMESPACES;
    i18next.use(Backend).use(initReactI18next).init({
        react: {
            useSuspense: true,
            wait: false
        },
        fallbackLng: 'he',
        ns: namespaces,
        debug: false,
        interpolation: {escapeValue: false},  // React already does escaping
        lng: ['en', 'he'],                              // language to use
        backend: {
            loadPath: '/locale/{{lng}}/{{ns}}.json',
            // addPath: '/locale/{{lng}}/{{ns}}.json',
            allowMultiLoading: true
        },
        // saveMissing: true
    }).then(() => {
        const lang = detectLanguage();
        return i18next.changeLanguage(lang);
    }).catch((e) => {
        // Never let this chain fail silently — a swallowed rejection here leaves
        // react-i18next suspended and the app stuck on the loader.
        console.error('i18n init/changeLanguage failed', e);
    });
};

export default configI18next;
